import styled from 'styled-components';
import { useGTM } from '../../hooks/useGTM';

interface CardProps {
  $variant?: 'default' | 'glass';
  $hoverable?: boolean;
  title?: string;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

const StyledCard = styled.div<CardProps>`
  padding: ${({ theme }) => theme.spacing.lg};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: ${({ $variant, theme }) =>
    $variant === 'glass' ? theme.effects.glassMorphism : theme.colors.background.light};
  transition: transform 0.3s ease;

  ${({ $hoverable }) =>
    $hoverable &&
    `
    &:hover {
      transform: translateY(-4px);
    }
  `}
`;

export const Card = ({ children, onClick, title, ...props }: CardProps) => {
  const { pushEvent } = useGTM();

  const handleClick = (e: React.MouseEvent) => {
    pushEvent('card_click', {
      card_title: title,
      card_type: props.$variant,
      page: window.location.pathname
    });

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledCard {...props} onClick={handleClick}>
      {children}
    </StyledCard>
  );
};

export const CardHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const CardContent = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CardFooter = styled.div`
  margin-top: ${({ theme }) => theme.spacing.md};
  padding-top: ${({ theme }) => theme.spacing.md};
  border-top: 1px solid ${({ theme }) => theme.colors.primary.main}20;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.xl};
`; 